<template>
    <div class="form-group has-error">
      <b-form-group
          id="fieldset-1"
          :description="params.description"
          :label="params.label"
          label-for="input-1"
          :invalid-feedback="invalidFeedback"
          :valid-feedback="validFeedback"
          :state="state"
      >
        <b-input-group>

          <template v-if="localMode === 'input'">
            <template v-if="localType === 'file'">
              <b-form-file :id="key"
                            v-bind:value="localValue"
                            v-on:input="on_input"
                            :state="state"
                            :disabled="localDisabled"
                            :type="localType"
                            placeholder="Выберите или перетащите файл"
                            trim>

              </b-form-file>
            </template>
            <template v-else>
              <b-form-input :id="key"
                            v-bind:value="localValue"
                            v-on:input="on_input"
                            :state="state"
                            :placeholder="placeholder"
                            :disabled="localDisabled"
                            :type="localType"
                            trim>

              </b-form-input>
            </template>

          </template>

          <template v-if="localMode === 'date_picker'">
            <DatePicker
                :value="localValue"
                :state="state"
                :disabled="localDisabled"
                :type="localType"
                :format="momentFormat"
                v-on:input="on_input"
            >
            </DatePicker>

          </template>


          <b-form-select :id="key"
                        v-if="localMode === 'select'"
                        :value="localValue"
                        @input="on_input"
                        :state="state"
                        :disabled="localDisabled"
                        :options="localOptions"
                        trim>

          </b-form-select>

          <template v-if="localMode === 'select2'">
            <div class="autosave-select2-wrapper">
              <v-select :id="key"
                            :value="select2_value"
                            @input="on_input"
                            @search="on_search"
                            :state="state"
                            :options="localOptions"
                            :disabled="localDisabled"
                            :reduce="item => item.value"
                            :clearable="false"
                            label="text"
                            >
                <template slot="no-options">
                  Введите 3 или более символа для поиска..
                </template>

              </v-select>
            </div>
          </template>

          <b-form-textarea :id="key"
                        v-if="localMode === 'textarea'"
                        :value="localValue"
                        @input="on_input"
                        :state="state"
                        :disabled="localDisabled"
                        :options="options"
                        max-rows="12"
                        trim>

          </b-form-textarea>

          <template v-if="localMode === 'trix'">
            <div class="autosave-trix-wrapper">
              <VueTrix :inputId="key" v-model="localValue" placeholder="enter your content..."/>
            </div>
          </template>

          <b-input-group-append v-if="changed">
            <b-button variant="outline-primary" @click="save_data" v-if="valid">
              <icon icon="save"></icon>
            </b-button>
            <b-button variant="outline-secondary" @click="reset_data">
              <icon icon="redo-alt"></icon>
            </b-button>
          </b-input-group-append>
        </b-input-group>
      </b-form-group>
    </div>
</template>


<script charset="utf-8">
// AutosaveInput
import VueTrix from "vue-trix";
import vSelect from 'vue-select';
import DatePicker from 'vue2-datepicker';
import moment from 'moment'

import Icon from './Icon';
import {compose_collection} from "../shared/helpers";
import {show_api_error} from "../shared/api_errors";

export default {
  components: {
    VueTrix, Icon, vSelect, DatePicker
  },
  props: ['params', 'id', 'record_type', 'url', 'value', 'index', 'type'],

  // params: {
  //   mode: 'input', // input | select | select2 | textarea | trix
  //   type: 'text', // any html5 input type
  //   collection: [], // array of objects
  //   get_options_url: '', // url for ajax filter options for select2 mode
  //   option_label: 'title', // url for ajax filter options for select2 mode
  // }

  data() {
    return {
      firstValue: this.value ? this.value : (this.params && this.params.value ? this.params.value : ''),
      prevValue:  this.value ? this.value : (this.params && this.params.value ? this.params.value : ''),
      localValue: this.value ? this.value : (this.params && this.params.value ? this.params.value : ''),
      localState: 'stored',
      localOptions: this.params.collection,
      localEmptyOption: this.params.empty_option,
      placeholder: this.params.placeholder,
      one_word_search: this.params.one_word_search,
      get_options_url: this.params.get_options_url,
      option_label: this.params.option_label ? this.params.option_label : 'name',
      localTimeout: null,
      localDisabled: this.params.disabled != undefined ? this.params.disabled : false ,
      localRequestFormat: 'application/json',

      // Use moment.js instead of the default
      momentFormat: {
        // Date to String
        stringify: (date) => {
          return date ? moment(date).format('LL') : ''
        },
        // String to Date
        parse: (value) => {
          return value ? moment(value, 'LL').toDate() : null
        }
      },
    }
  },
  computed: {
    //state of component
    state() {
      let s = null;
      if (this.localState === 'saved') {s=true};
      if (!this.valid || this.changed) {s=false};
      return s;
    },
    invalidFeedback() {
      if (this.changed) {
        if (this.valid) {
          return 'Не сохранено';
        } else {
          return 'Обязательное поле'
        }
      } else {
        return ''
      }
    },
    validFeedback() {
      return this.localState === 'saved' ? 'Сохранено' : ''
    },
    changed() {
      return (this.localState === 'changed');
    },
    saved() {
      return (this.localState === 'saved');
    },
    valid() {
      return (!(this.params.required === true) || (String(this.localValue).length > 0))
    },
    localMode() {
      return (this.params.mode === undefined ? 'input' : this.params.mode);
    },
    localType() {
      return (this.params.type === undefined ? 'text' : this.params.type);
    },
    key() {
      return `${this.localMode}-${this.params.field}-${this.id}`
    },
    request_type(){
      return this.id ? 'PATCH' : 'POST';
    },
    options() {
      return this.localOptions
      // return this.params.collection
    },
    select2_value(){
      return _.find(this.stringified_options, {value: String(this.localValue)});
    },
    stringified_options() {
      return _.map(this.options, (el) => {
        return {text: el.text, value: String(el.value)}
      });
    },
    ajaxProcessData(){
      return !(this.localMode == 'input' && this.localType == 'file')
    },
    ajaxContentType(){
      return (this.localMode == 'input' && this.localType == 'file') ? false : undefined
    }
  },
  watch: {
    value: function (newValue, oldvalue) {
      // console.log('value prop changed!!! ',newValue);
      this.localValue = newValue;
      this.prevValue = newValue;
      this.correct_values();
    },
    localValue: function(newVal, oldVal) {
      // console.log('change value to',newVal);
      this.on_input(newVal);
    },
    params: function (newParams, oldParams) {
      // console.log('params changed!!! ',newParams);
      if (newParams.collection) {
        this.correct_options(newParams.collection);
      }
    },
  },

  beforeMount() {
    this.correct_values();
  },

  beforeUpdate: function() {
    // console.log('Autosave - beforeUpdate!');
    this.$set(this, 'get_options_url', this.params.get_options_url);
    this.$set(this, 'option_label', this.params.option_label ? this.params.option_label : 'name');
    //this.$set(this, 'localOptions', this.params.collection);
  },

  methods:{
    correct_values(){
      if (this.value === undefined){
        this.firstValue = this.params && this.params.value ? this.params.value : '' ;
      } else {
        this.firstValue = this.value;
      }

      if (this.localMode === 'date_picker') {
        this.firstValue = moment(this.localValue, moment.defaultFormat).toDate();
      }
      this.prevValue = this.localValue = this.firstValue;

      if ((this.localMode === 'select') || (this.localMode === 'select2')) {
        this.correct_options(this.params.collection);
      }

    },
    correct_options(coll){
      // преобразуем только если в коллекции отсутствует ключ text.
      // это означает что передана неподготовленная коллекция.
      if ((coll.length > 0) && (coll[0] !== undefined) && (typeof(coll[0]) === 'object') && (coll[0].text === undefined) &&  (coll[0].label === undefined) ) {
        // console.log('Autosave - correct options..', coll);
        if (coll[0].attributes === undefined) {
          console.error('AutosaveInput ERROR: collection has no "attributes" key.')
          this.$set(this, 'localOptions', []);
        } else {
          if (coll[0].attributes[this.option_label] === undefined) {
            console.error(`AutosaveInput ERROR: collection has no [${this.option_label}] key.`)
            this.$set(this, 'localOptions', []);
          } else {
            // console.log('run..');
            this.$set(this, 'localOptions', compose_collection(coll, this.option_label, this.localEmptyOption));
            // console.log('Successfull.');
          }
        }
      } else {
        this.$set(this, 'localOptions', coll);
      }
    },

    on_search (search, loading) {
      console.log(search);

      if ((this.get_options_url !== undefined) && (search.length > 2)) {
        if (this.one_word_search && search.includes(' ')) {
          // skip ajax request but continue filtering
        } else {
          loading(true);
          this.search(search, loading);
        }
      }
    },

    on_input (e) {
      // console.log('on_input', e);

      this.$set(this, 'localValue', e);

      // console.log(this.localValue, this.prevValue);
      clearTimeout(this.localTimeout);
      if (this.localValue === this.prevValue) {
        // console.log('stored');
        this.$set(this, 'localState', 'stored');
      } else {
        // console.log('changed');
        this.$set(this, 'localState', 'changed');
      }

      this.$emit('input', e, this.params.field);
    },

    on_filter (options, search ) {
      // console.log('on_filter', options);
      return options.filter();
    },

    search (search, loading) {
      let vc = this;
      // search_data — плоские query-параметры для запроса опций (extra_data уходит вложенным
      // в record_type только при сохранении)
      let data = Object.assign({filter: search}, this.params.search_data);

      // console.log('sending data:', data);
      $.ajax({
          url: this.get_options_url,
          // url: `${this.get_options_url}.${vc.localRequestFormat}`,
          data: data,
          dataType: "json",
          headers: {
            accept: vc.localRequestFormat
          },
          type: 'GET'
        })
        .done( function(data) {
          // console.log('Успешно.', data);
          let items = data.data;
          vc.$set(vc, 'localOptions', compose_collection(data.data, vc.option_label));
          loading(false);
        })
        .fail( function(jqXHR) {
          show_api_error(vc, jqXHR);
          loading(false);
        })

    },

    save_data (e) {
      this.submit_data(e);
    },

    reset_data (e) {
      clearTimeout(this.localTimeout);
      this.$set(this, 'localState', 'stored');
      this.$set(this, 'localValue', this.prevValue);
    },

    setLocalState (s) {
      clearTimeout(this.localTimeout);
      this.$set(this, 'localState', s);
    },

    submit_data(e) {
      let vc = this;
      let data;
      if (this.localMode == 'input' && this.localType == 'file') {
        data = new FormData();
        data.append(`${this.record_type}[${this.params.field}]`, document.getElementById(this.key).files[0] );
        _.forIn(this.params.extra_data, function(v, k){
          data.append(`${vc.record_type}[${k}]`, v );
        })
      } else {
        data = {[this.record_type]: {[this.params.field]: this.localValue}};
        // data = {[this.record_type]: {[this.params.field]: document.getElementById('input-file-1').files[0]}};
        data[this.record_type] = Object.assign(data[this.record_type], this.params.extra_data);

      }

      // formData.append(`${this.record_type}[${this.params.field}]`, document.getElementById('input-file-1').files[0], this.localValue.name);
      // console.log('localValue:', this.localValue.name);
      // console.log('sending data:', data);
      // console.log('sending fdata:', formData);
      $.ajax({
          url: this.url,
          processData: this.ajaxProcessData,
          contentType: this.ajaxContentType,
          data: data,
          dataType: "json",
          format: vc.localRequestFormat,
          type: vc.request_type
        })
        .done( function(data) {
          // console.log('Успешно.', data);
          let item = data.data;
          let new_saved_val = item.attributes[vc.params.field];
          if (new_saved_val === null) new_saved_val = '';
          vc.$set(vc, 'localValue', new_saved_val);
          vc.$emit('on_save', item, vc.index, vc.params.field, vc.localValue,  data);
          clearTimeout(vc.localTimeout);
          vc.$set(vc, 'prevValue', vc.localValue);
          vc.$set(vc, 'localState', 'saved');
          vc.$set(vc, 'localTimeout', setTimeout(vc.setLocalState, 2000, 'stored'));

        })
        .fail( function(jqXHR) {
          show_api_error(vc, jqXHR);
        })
      // $.ajax({
      //     url: this.url,
      //     data: data,
      //     dataType: "json",
      //     format: vc.localRequestFormat,
      //     type: vc.request_type
      //   })
      //   .done( function(data) {
      //     console.log('Успешно.', data);
      //     let item = data.data;
      //     vc.$emit('on_save', item, vc.index, vc.params.field, vc.localValue,  data);
      //     clearTimeout(vc.localTimeout);
      //     vc.$set(vc, 'prevValue', vc.localValue);
      //     vc.$set(vc, 'localState', 'saved');
      //     vc.$set(vc, 'localTimeout', setTimeout(vc.setLocalState, 2000, 'stored'));
      //
      //   })
      //   .fail( function(jqXHR, textStatus) {
      //     var errors = jqXHR.responseJSON;
      //     console.error(errors);
      //     alert(`Ошибка загрузки - ${vc.url}.`);
      //   })
    }
  },
}
</script>

<style scoped>
  .autosave-trix-wrapper {
    max-width: calc(100% - 85px);
  }

  .autosave-select2-wrapper {
    width: calc(100% - 85px);
    max-width: calc(100% - 85px);
  }

  .site .autosave-select2-wrapper {
    width: calc(100% - 120px);
    max-width: calc(100% - 120px);
  }

</style>